<template>
  <b-modal
      id="kplus-account-modal"
      hide-footer
      size="xl"
      title="ลงทะเบียนระบบออโต้ KPlus"
  >
    <b-overlay :show="isFetching">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider
              v-slot="{ errors }"
              name="pin"
              rules="required"
          >
            <b-form-group label="Pin">
              <b-form-input
                  v-model="form.pin"
                  :aria-invalid="false"
                  :state="errors[0] ? false : null"
                  name="pin"
                  placeholder="พินแอพ KPlus"
                  type="text"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
              v-slot="{ errors }"
              name="state"
              rules="required"
          >
            <b-form-group label="State">
              <b-form-textarea
                  v-model="form.state"
                  :aria-invalid="false"
                  :state="errors[0] ? false : null"
                  name="state"
                  placeholder="State จากแอพที่ติดตั้งในโทรศัพท์"
              ></b-form-textarea>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <div class="text-right">
            <a class="btn btn-primary mr-2" download href="/kplus/kplusdevice-extension.zip">
              <i class="uil-download-alt"></i>
              ดาวน์โหลดส่วนเสริม
            </a>
            <b-button :disabled="isFetching" type="submit" variant="success">
              ลงทะเบียน
            </b-button>
          </div>
        </form>
      </ValidationObserver>
    </b-overlay>
  </b-modal>
</template>

<script>
import Vue from 'vue';
import {mapActions} from 'vuex';

export default Vue.extend({
  name: 'KPlusAccountModal',
  props: {
    agentBankAccountId: {
      type: String,
      required: true
    },
    kplusAccount: {
      type: Object,
      default: () => ({
        pin: '',
        state: '',
      })
    }
  },
  data() {
    return {
      isFetching: false,
      form: {
        pin: '',
        state: ''
      }
    }
  },
  created() {
    this.form = {
      pin: this.kplusAccount?.pin || '',
      state: this.kplusAccount?.state || '',
    }
  },
  methods: {
    ...mapActions(['registerKPlus', 'fetchBankAccount']),
    async onSubmit() {
      this.isFetching = true
      const response = await this.registerKPlus({ id: this.agentBankAccountId, data: this.form })
      if(response) {
        this.$bvModal.hide('kplus-account-modal')
        await this.fetchBankAccount(this.agentBankAccountId)
      }
      this.isFetching = false
    },
  }
})
</script>

<style scoped>

</style>